import { render, staticRenderFns } from "./CRUDTableNationality.vue?vue&type=template&id=a4b4cd14"
import script from "./CRUDTableNationality.vue?vue&type=script&lang=js"
export * from "./CRUDTableNationality.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableNationality.vue?vue&type=style&index=0&id=a4b4cd14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports